"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectError = exports.removeError = exports.apiCallRequestedChannel = exports.apiCallErrorChannel = exports.apiCallSuccessChannel = void 0;

var actions = _interopRequireWildcard(require("./apiActions"));

var apiCallSuccessChannel = function apiCallSuccessChannel(endpointName) {
  return function (action) {
    return action.type === actions.API_CALL_SUCCESS && action.endpointName === endpointName;
  };
};

exports.apiCallSuccessChannel = apiCallSuccessChannel;

var apiCallErrorChannel = function apiCallErrorChannel(endpointName) {
  return function (action) {
    return action.type === actions.API_CALL_ERROR && action.endpointName === endpointName;
  };
};

exports.apiCallErrorChannel = apiCallErrorChannel;

var apiCallRequestedChannel = function apiCallRequestedChannel(endpointName) {
  return function (action) {
    return action.type === actions.API_CALL_REQUESTED && action.endpointName === endpointName;
  };
};

exports.apiCallRequestedChannel = apiCallRequestedChannel;

var removeError = function removeError(errors, endpointName) {
  var newErrors = [];
  errors.forEach(function (error) {
    if (error.endpointName !== endpointName) {
      newErrors.push(error);
    }
  });
  return newErrors;
};

exports.removeError = removeError;

var selectError = function selectError(errors, endpointName) {
  var result = errors.filter(function (error) {
    return error.endpointName === endpointName;
  });
  return result[0];
};

exports.selectError = selectError;